import React from 'react'

import { useParams, useNavigate } from 'react-router-dom'
import { isAfter } from 'date-fns'
import { useTheme } from 'styled-components'

import { useDate } from '@hooks/dates'
import { useFindTask } from '@hooks/task/find'

import { Banner } from '../../../../components/Banner'

export function FutureTaskBanner() {
  const theme = useTheme()
  const { getWeekRange } = useDate()
  const { taskId } = useParams<{ taskId: string }>()

  const { data: rawTask } = useFindTask(Number(taskId))

  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  const { weekEnd } = getWeekRange(new Date())

  const isStartTimeAhead = isAfter(new Date(task.startTime), weekEnd)

  return (
    <>
      {isStartTimeAhead && (
        <Banner backgroundColor={theme.colors.isPullAhead}>
          This is a future task. Changes made here may be overwritten by the
          next import.
        </Banner>
      )}
    </>
  )
}
